import EmailForm from "./components/EmailForm";
import "./App.css";

function App() {
  return (
    <div>
      <EmailForm />
    </div>
  );
}

export default App;
